import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import HubsEntityCollection from '../../../../../components/HubsEntityCollection';
import Form from '../../../../../components/Form';
import Label from '../../../../../components/Label';
import messages from '../../messages';
import '../../styles.css';

const ErrorLabel = <Label role="tooltip" basic color="red" pointing><FormattedMessage {...messages.invalidError} /></Label>;

const numberConstraints = {
  type: 'number',
  min: '0',
  max: '9',
};

export const EntityComponent = ({ entity, handleChange, order, collection }) => (
  <div styleName="field">
    <label styleName="menu-field-label" htmlFor={`${entity.eid}-required`}>
      Years Required
    </label>
    <Form.Input
      error={get(entity, 'showError.requiredYears')}
      {...numberConstraints}
      name="requiredYears"
      fluid
      placeholder="Years Required"
      value={entity.requiredYears}
      order={order}
      onChange={(e, value) => handleChange(e, {
        value: value.value,
        order,
        name: 'requiredYears',
        field_he_prerequisitetype: get(collection, 'editor.cmsDataMapping.highSchoolMetaData.field_he_prerequisitetype.allowed_values', {})[entity.type],
      }, null, order)}
    />
    {get(entity, 'showError.requiredYears') && ErrorLabel}
    <label styleName="menu-field-label" htmlFor={`${entity.eid}-recommended`}>
      Years Recommended
    </label>
    <Form.Input
      error={get(entity, 'showError.recomendationYears')}
      {...numberConstraints}
      name="recomendationYears"
      fluid
      placeholder="Years Recommended"
      value={entity.recomendationYears}
      order={order}
      onChange={(e, value) => handleChange(e, {
        value: value.value,
        order,
        name: 'recomendationYears',
        field_he_prerequisitetype: get(collection, 'editor.cmsDataMapping.highSchoolMetaData.field_he_prerequisitetype.allowed_values', {})[entity.type],
      }, null, order)}
    />
    {get(entity, 'showError.recomendationYears') && ErrorLabel}
  </div>
);

EntityComponent.propTypes = {
  entity: PropTypes.object,
  handleChange: PropTypes.func,
  order: PropTypes.number,
  collection: PropTypes.object,
};

const RecommendedCourses = ({ onChange, ...props }) => (
  <HubsEntityCollection
    {...props}
    disableRemove
    _key="he_prerequisitetype"
  >
    <EntityComponent handleChange={onChange} />
  </HubsEntityCollection>
);

RecommendedCourses.propTypes = {
  initialValue: PropTypes.array,
  onChange: PropTypes.func,
  mapper: PropTypes.object,
};

export default RecommendedCourses;
